import React, { useEffect, useContext, useState } from "react";
import { Button } from "react-bootstrap";
import Header from "../../Header";
import Footer from "../../Footer";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";

// Images
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

// Context API
import { mobilePageContext } from "/src/App";
import { toast } from "react-toastify";
import axios from "axios";
import Loader from "../../../Loader";

import OuterCalculator from "../../../OuterCalculator";
import { blobURL } from "common/StringUtils";
import { Reviews } from "components/feedback/Reviews";
import BusinessContactUs from "./BusinessContactUs";
import { LOCALES } from "common/constants";
import { getSchemaMarkup } from "common/FunctionUtils";

const Business = ({ dashboardFooter }) => {
  const schemaMarkup = getSchemaMarkup("foretag");
  const newchoose = `${blobURL}/new_achived.svg`;
  const employeeWork = `${blobURL}/business_banner_2.jpg`;
  const bannerEng = `${blobURL}/business_banner_eng.png`;
  const bannerDe = `${blobURL}/business_banner_de.png`;

  const [validated, setValidated] = useState(false);
  const [loading, setLoading] = useState(false);

  const language = localStorage.getItem("i18nextLng");

  const mobilepageContext = useContext(mobilePageContext);
  const location = useLocation();
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const user = useSelector((state) => state.auth.user);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
      return;
    }
    setValidated(false);
    setLoading(true);
    const {
      validationCustom01: { value: firstName },
      validationCustom02: { value: lastName },
      validationCustom03: { value: email },
      validationCustom04: { value: phoneNumber },
      validationCustom05: { value: message },
    } = form.elements;
    try {
      const URL = "/contactus";
      const formData = {
        name: `${firstName} ${lastName}`,
        subject: "New message from Invozio business page",
        email,
        phoneNumber,
        isBusiness: true,
        message,
      };

      const result = await axios.post(URL, formData);
      if (result.status === 200) {
        setLoading(false);
        form.reset();
        setValidated(false);
        toast.success(
          t(
            "Your message has been sent successfully. We will get back to you shortly"
          )
        );
      } else {
        setLoading(false);
        toast.error(t("Server Error, Please contact Administrator"));
      }
    } catch (error) {
      setLoading(false);

      if (error?.response) {
        toast.error(error?.response?.data?.message);
      }
    }
  };

  return (
    <>
      {loading && <Loader />}
      <Helmet>
        {schemaMarkup && (
          <script type="application/ld+json">
            {JSON.stringify(schemaMarkup)}
          </script>
        )}
        <title>{t("Assignment negotiation Help - Contact Invozio")}</title>
        <meta
          name="description"
          content={t(
            "Not sure about compensation and conditions for your assignment? Invozio helps you negotiate with your client. Contact us for more information."
          )}
        />
        {language === LOCALES.EN_US ? (
          <link rel="canonical" href="https://invozio.com/business" />
        ) : (
          <link rel="canonical" href="https://invozio.com/foretag" />
        )}
      </Helmet>

      {mobilepageContext === false &&
      location?.pathname === "/mobile_business_solution" ? (
        ""
      ) : (
        <Header />
      )}

      <div className="p-0 self_new negotiate network-page mb-0 nw_add_scc busniness_new">
        <div className="negotiation_wrap new_desgn_insurance inspiration fakt new_margin_header px-0 p-0">
          <section className="negotiation business banner set_banner_height">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-6">
                  <div className="security_fntw">
                    <h1 className="security_about text-uppercase mb-0">
                      {t("BUSINESS - PERSONNEL MANAGEMENT")}
                    </h1>
                    {/* <div className="secnd_text mb-2">
                      <p className="collct_info fnt_family">
                        {t("WE HANDLE YOUR")}
                      </p>
                      <p className="collct_info fnt_family">
                        {t("CONSULTANTS’ PAYROLLS!")}
                      </p>
                    </div> */}
                    <p className="fnt_businss">
                      {t(
                        "Invozio offers businesses an efficient solution for payroll payments to consultants and additional staff with clear pricing and no hidden fees. A fee of 1.9% of the invoiced amount is applied, with a minimum fee of 190 SEK if 1.9% is lower. We handle everything from accounting and taxes to annual reports, allowing you to focus on growing your business. Streamline your personnel management and reduce administrative costs with Invozio."
                      )}
                    </p>
                    {mobilepageContext === false &&
                    location?.pathname === "/mobile_business_solution" ? (
                      ""
                    ) : (
                      <>
                        {!user ? (
                          <Button
                            className="mt-3 new_theme_btn "
                            onClick={() => {
                              navigate(
                                language === LOCALES.EN_US
                                  ? `/emailregister?lang=${LOCALES.EN_US}`
                                  : `/e-postregister?lang=${LOCALES.SV_SE}`
                              );
                              sessionStorage.setItem("accountType", 2);
                            }}
                          >
                            {t("Create Free Account")}
                          </Button>
                        ) : (
                          ""
                        )}
                      </>
                    )}
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="text-right">
                    <div className="image_wrap new_wrap bordernone">
                      <img
                        src={language === LOCALES.SV_SE ? bannerDe : bannerEng}
                        alt="invoice-negotation"
                        className="img-fluid"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <Reviews />

          <section className="new_scts trustplot_sctn new_desig_tooltip pb-5">
            <div className="container container-dynamic pb-0">
              <div
                className="trustpilot-widget"
                data-locale={LOCALES.SV_SE}
                data-template-id="5406e65db0d04a09e042d5fc"
                data-businessunit-id="64f712e3dbd20bbfcf3a825f"
                data-style-height="28px"
                data-style-width="100%"
                data-theme="light"
              >
                <a
                  href="https://se.trustpilot.com/review/invozio.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Trustpilot
                </a>
              </div>
            </div>
          </section>

          <section className="newdesign business new_busins_desgn">
            <div className="container p-0">
              <div className="sectin_new">
                <div className="row justify-content-center align-items-center">
                  <div className="col-lg-6">
                    <div className="invoice_text">
                      <div className="text-heading mb-3">
                        <h2>{t("How does it work?")}</h2>
                      </div>
                      <p>
                        {t(
                          "Whether your company is in the consulting industry, a startup, or a growing business, we are here to facilitate payroll and insurance for you. Here is a simple summary of the process:"
                        )}
                      </p>
                      <ol className="mt-3">
                        <li>
                          <p></p>
                          <div>
                            <p>{t("Register your company profile")}</p>
                          </div>
                        </li>
                        <li>
                          <p></p>
                          <div>
                            <p>
                              {t(
                                "Specify working hours or a fixed price before the invoicing process."
                              )}
                            </p>
                          </div>
                        </li>
                        <li>
                          <p></p>
                          <div>
                            <p>
                              {t(
                                "Once the invoice is paid, we ensure that the consultants receive their salary within 48 hours."
                              )}
                            </p>
                          </div>
                        </li>

                        <li>
                          <p></p>
                          <div>
                            <p>
                              {t(
                                "We handle all accounting, pay slips, vacation pay, and pension contributions, so you can continue to focus on your business."
                              )}
                            </p>
                          </div>
                        </li>
                      </ol>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="invoice_choose">
                      <img
                        src={newchoose}
                        className="img-fluid"
                        alt="how-does-it-work"
                        loading="lazy"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="try new_try_sectn">
            <div className="container">
              <div className="row">
                <div className="col-md-4 mb-3 mb-md-3">
                  <div className="card h-100 rounded-lg text-center">
                    <h4 className="font-weight-bold">#{t("Commitment")}</h4>
                    <p className="mb-0">
                      {t(
                        "We take full employer responsibility for your staff, regardless of company size, which demonstrates our strong commitment to their well-being and development."
                      )}
                    </p>
                  </div>
                </div>
                <div className="col-md-4 mb-3 mb-md-3">
                  <div className="card h-100 rounded-lg text-center">
                    <h4 className="font-weight-bold">#{t("Efficiency")}</h4>
                    <p className="mb-0">
                      {t(
                        "By handling payroll administration, we take the administrative burden off your shoulders, freeing up your time and increasing the company's efficiency."
                      )}
                    </p>
                  </div>
                </div>
                <div className="col-md-4 mb-3 mb-md-3">
                  <div className="card h-100 rounded-lg text-center">
                    <h4 className="font-weight-bold">#{t("Security")}</h4>
                    <p className="mb-0">
                      {t(
                        "Through our insurance solutions, we create a sense of security for your staff, which leads to a positive work environment and increased productivity."
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="newdesign business new_busins_desgn employee_sctn pb-0">
            <div className="container p-0">
              <div className="sectin_new">
                <div className="row justify-content-center align-items-center">
                  <div className="col-lg-6">
                    <div className="employee_image">
                      <img
                        src={employeeWork}
                        className="img-fluid"
                        alt="employee_work"
                        loading="lazy"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="invoice_text nw_txt_cntr">
                      <div className="text-heading mb-3">
                        <h2>{t("How does it work for the employee?")}</h2>
                      </div>
                      <p>
                        {t(
                          "Consultants and additional staff who do not own a company can easily and securely become self-employed through Invozio."
                        )}
                      </p>
                      <p>
                        {t(
                          "This ensures that the consultant is insured during assignments and receives their salary on time. In addition to this, we have a fantastic support team available via phone, email, and chat, ready to assist if any questions or concerns arise."
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <OuterCalculator />

          <section className="calculate-salary pt-2 pb-0 new_calculte_designs new_busins_desgn clr_diff">
            <div className="text-heading text-center mb-3">
              <h2>{t("WHAT DO THE CUSTOMERS SAY")}</h2>
            </div>
            <div className="padding_set">
              <div className="container container-dynamic my-4">
                <div
                  className="trustpilot-widget"
                  data-locale={LOCALES.SV_SE}
                  data-template-id="54ad5defc6454f065c28af8b"
                  data-businessunit-id="64f712e3dbd20bbfcf3a825f"
                  data-style-height="240px"
                  data-style-width="100%"
                  data-theme="light"
                  data-stars="5"
                  data-review-languages="sv"
                >
                  <a
                    href="https://se.trustpilot.com/review/invozio.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Trustpilot
                  </a>
                </div>
                <div
                  className="trustpilot-widget mt-md-0 mt-3"
                  data-locale={LOCALES.SV_SE}
                  data-template-id="5406e65db0d04a09e042d5fc"
                  data-businessunit-id="64f712e3dbd20bbfcf3a825f"
                  data-style-height="28px"
                  data-style-width="100%"
                  data-theme="light"
                >
                  <a
                    href="https://se.trustpilot.com/review/invozio.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Trustpilot
                  </a>
                </div>
              </div>
            </div>
          </section>

          <BusinessContactUs
            t={t}
            dashboardFooter={dashboardFooter}
            validated={validated}
            handleSubmit={handleSubmit}
          />
        </div>
      </div>

      {mobilepageContext === false &&
      location?.pathname === "/mobile_business_solution" ? (
        ""
      ) : (
        <Footer dashboardFooter={dashboardFooter} />
      )}
    </>
  );
};

export default Business;
